import { PreviewModal } from "../components/PreviewModal"
import React from "react";

interface Props {}

export const OrangePTPreview: React.FC<Props> = props => {
 return (<>
  <PreviewModal shape="16:9" playlistId={19422} onClose={() => {  }} />
 </>)
}